import { useVendorsApiClient } from 'vendors/api/useVendorsApiClient'
import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

export const useGetProposalPdf = (): UseMutationResult<AxiosResponse<string>, unknown, string, unknown> => {
  const { getProposalPdf } = useVendorsApiClient()
  return useMutation({
    mutationFn: (proposalId: string) => getProposalPdf(proposalId)
  })
}
